<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Masters <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Year Of Passing Master <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Edit Year</h1>
            <div class="content-wrap">
                <form [formGroup]="editYearForm">
                    <div class="row">
                        <div class="col-md-3">                            
                            <div class="form-group input-group-lg">
                                <label for="yearOfPass" class="form-label">Year<span
                                        class="color-red">*</span></label>
                                <input type="text" placeholder="Enter the college name" formControlName="yearOfPass"
                                    [(ngModel)]="yearOfPass" class="form-control form-input" id="yearOfPass"
                                    [ngClass]="{'is-invalid': submitted && f.yearOfPass.errors }"/>
                                <div *ngIf="submitted && f.yearOfPass.errors" class="invalid-feedback"> 
                                    <div *ngIf="f.yearOfPass.errors.required">college Name is required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="proceed-btn" (click)="updateYear()">Submit</button>   
                    <button class="proceed-btn" (click)="refresh()">Cancel</button>                   
                </form>
            </div>
        </div>
    </div>
</div>
<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap"><img src="assets/images/thumb-up.png" class="fa-icon-modal"
                        alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">{{strMessage}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>
</ng-template>